const TableRowColors = {
  GREEN: 'green',
  DARK_GREEN: 'darkgreen',
  YELLOW: 'yellow',
  LIGHT_BLUE: 'lightblue',
  DARK_BLUE: 'darkblue',
  TEAL: 'teal',
  ORANGE: 'orange',
  RED: 'red',
} as const;

export default TableRowColors;
